import fr from './fr';
import en from './en';
import nl from './nl';
import de from './de';
import es from './es';
import lb from './lb';

/**
 * Contenu des pages légales, une langue par fichier.
 *
 * Le repli est le FRANÇAIS et non l'anglais : c'est la langue du vendeur, du
 * siège (Belgique) et du droit applicable, et c'est déjà le repli du reste du
 * site (voir i18n/languages.js, DEFAULT_LANG). Une langue partiellement
 * traduite retombe donc document par document, jamais sur une page vide.
 */
const CONTENUS = { fr, en, nl, de, es, lb };

/** Métadonnées communes à toutes les langues : adresse de la page et mots-clés. */
const ROUTES = {
  cgv: { url: '/terms', motsCles: 'CGV, conditions générales de vente, droit de rétractation, livraison' },
  confidentialite: { url: '/privacy', motsCles: 'confidentialité, RGPD, données personnelles, cookies' },
  mentions: { url: '/legal', motsCles: 'mentions légales, informations entreprise, TVA' },
  paiement: { url: '/payment-security', motsCles: 'sécurité paiement, Stripe, PCI-DSS, paiement sécurisé' },
};

export function documentLegal(cle, langue) {
  const contenu = CONTENUS[langue] || CONTENUS.fr;
  const doc = contenu[cle] || CONTENUS.fr[cle];
  return { ...ROUTES[cle], ...doc };
}
